import { useState, useEffect } from "react";
import { Row, Col, Skeleton, Typography } from "antd";
import OrderExpressService from "../../utils/api/orders-express";
import OrdersExpressTable from "./Table";
import LayoutPage from "../../layouts/Main";
import "../../../src/scss/ordenesExpressStyles.scss";

const { Title } = Typography;

export default function OrdersExpress(props) {

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    OrderExpressService.GetAll()
      .then(resp => {
        const incomingOrders = Array.isArray(resp?.data?.orders) ? resp.data.orders : [];

        const sessionAttachmentMap = window.__ordersExpressAttachments || {};

        let localAttachmentMap = {};
        try {
          const rawLocalAttachments = localStorage.getItem('orders_express_local_attachments');
          localAttachmentMap = rawLocalAttachments ? JSON.parse(rawLocalAttachments) : {};
        } catch (error) {
          localAttachmentMap = {};
        }

        const ordersWithAttachments = incomingOrders.map((order) => {
          const currentAttachments = Array.isArray(order?.attachments)
            ? order.attachments
            : order?.attachments
              ? [order.attachments]
              : [];

          if (currentAttachments.length > 0) {
            return order;
          }

          const fallbackAttachments = sessionAttachmentMap[order?.id] || localAttachmentMap[order?.id];
          if (Array.isArray(fallbackAttachments) && fallbackAttachments.length > 0) {
            return {
              ...order,
              attachments: fallbackAttachments,
            };
          }

          return order;
        });

        setOrders(ordersWithAttachments);
      })
      .catch(() => setOrders([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <LayoutPage>
      <div className="orders-card">
        <Row gutter={[24, 16]}>
          <Col xs={24}>
            <Title level={3}>Órdenes Express</Title>
          </Col>
          <Col xs={24}>
            {loading ? (
              <Skeleton
                active
                paragraph={{ rows: 8 }} 
                title={false}
              />
            ) : (
              <OrdersExpressTable
                openOrders={orders}
                loading={false}      
              />
            )}
          </Col>
        </Row>
      </div>
    </LayoutPage>
  );
}